module.exports = __webpack_public_path__ + "public/SiteIcons/popular-left.png?81f0018d";